import { Svg } from '../../../components/Svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ContentAgentIcon = () => {
  return /*#__PURE__*/_jsxs(Svg, {
    $size: "32px",
    $color: "currentColor",
    $alignWithText: false,
    viewBox: "0 0 32 32",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M5 7H27C27.5467 7 28 6.54667 28 6C28 5.45333 27.5467 5 27 5H5C4.45333 5 4 5.45333 4 6C4 6.54667 4.45333 7 5 7Z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5 27H27C27.5467 27 28 26.5467 28 26C28 25.4533 27.5467 25 27 25H5C4.45333 25 4 25.4533 4 26C4 26.5467 4.45333 27 5 27Z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5 12H12C12.5467 12 13 11.5467 13 11C13 10.4533 12.5467 10 12 10H5C4.45333 10 4 10.4533 4 11C4 11.5467 4.45333 12 5 12Z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5 17H12C12.5467 17 13 16.5467 13 16C13 15.4533 12.5467 15 12 15H5C4.45333 15 4 15.4533 4 16C4 16.5467 4.45333 17 5 17Z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5 22H12C12.5467 22 13 21.5467 13 21C13 20.4533 12.5467 20 12 20H5C4.45333 20 4 20.4533 4 21C4 21.5467 4.45333 22 5 22Z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      d: "M27 10H17C16.4533 10 16 10.4533 16 11V21C16 21.5467 16.4533 22 17 22H27C27.5467 22 28 21.5467 28 21V11C28 10.4533 27.5467 10 27 10ZM26 20H18V12H26V20Z",
      fill: "currentColor"
    })]
  });
};
export default ContentAgentIcon;